var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShield2 = function SvgShield2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    fill: "none",
    viewBox: "0 0 14 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fill: "#C8D7F5",
    fillOpacity: 0.75,
    d: "M12.454 2.788a11.54 11.54 0 0 1-4.847-1.659 1.17 1.17 0 0 0-1.215 0 11.55 11.55 0 0 1-4.846 1.659A1.165 1.165 0 0 0 .5 3.948V7.41a7.17 7.17 0 0 0 3.686 6.264l2.247 1.249a1.16 1.16 0 0 0 1.133 0l2.248-1.249A7.17 7.17 0 0 0 13.5 7.411V3.947a1.165 1.165 0 0 0-1.046-1.16M9.653 6.789l-2.5 2.667a.666.666 0 0 1-.929.042l-1.5-1.333a.666.666 0 1 1 .885-.996l.288.255A1 1 0 0 0 7.29 7.36l1.39-1.482a.67.67 0 0 1 .852-.102.667.667 0 0 1 .121 1.013"
  }))));
};
export default SvgShield2;